import React from 'react';
import './About.css'
import aboutImage from '../portfolio.jpeg'
import cv from '../../Images/Abidur-cv.pdf'
import Header2 from '../Header/Header2';

const About = () => {
    return (
        <>
            <div className="row" >
                <div className="col-md-3">
                    <Header2 />
                </div>
                <div className="col-md-9">
                    <div className="text-center mt-4">
                        <h2>ABOUT</h2>
                        <hr className='theme-color' />
                    </div>

                    <div className="row" >
                        <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 about-section-image">
                            <img src={aboutImage} alt="" style={{ height: '400px' }} />
                        </div>
                        <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 about-content">
                            <div className='p-3'>
                                <h3 className='header-text'>Hi, I am <span className='theme-color'> Abidur Rahman </span></h3>
                                <p>I am a frontend web developer. I can provide clean code and pixel perfect design. I also make website more & more interactive with web animations.
                                </p>
                                <p> I am expert in React, Next.js, Node.js and ExpressJS.</p>
                                <ul>
                                    <li><b>Full Name </b>  Abidur Rahman Niloy</li>
                                    <li><b>Nationality </b> Bangladeshi</li>
                                    <li><b>Languages </b> Bangla (Native), English</li>
                                    <li><b>Address </b> Sylhet, Bangladesh</li>
                                    <li><b>Freelance </b> Available</li>
                                </ul>
                                <a href={cv} className='mi-button' download>DOWNLOAD CV</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;